<script setup>
import { computed } from "vue";
import Icon from "next/icon/Icon.vue";
import { useMapGetter } from "dashboard/composables/store";

defineProps({
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: [String, Object],
    default: null,
  },
});

const unreadCountGetter = useMapGetter("announcements/getUnreadCount");
const unreadCount = computed(() => {
  if (!unreadCountGetter.value) {
    return "";
  }

  return unreadCountGetter.value < 100 ? `${unreadCountGetter.value}` : "99+";
});
</script>

<template>
  <Icon v-if="icon" :icon="icon" class="size-4 inline-block" />
  <div class="flex-1 truncate min-w-0">{{ label }}</div>
  <span
    v-if="unreadCount"
    class="min-h-4 min-w-4 px-1 bg-n-ruby-9 rounded-full grid place-items-center text-[9px] leading-none text-n-ruby-3 flex-shrink-0"
  >
    {{ unreadCount }}
  </span>
</template>
